import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { DateRangeChip } from '../DateRangeChip/DateRangeChip';
export const GetLastUpdatedChipTID = (parentTestId)=>getTestIds(parentTestId);
export const LastUpdatedChip = (param)=>{
    let { testId, predicate, onChange } = param;
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    const { LastUpdatedChipTestIds } = useMemo(()=>GetLastUpdatedChipTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(DateRangeChip, {
        testId: testId,
        predicate: predicate,
        onChange: onChange,
        fieldLabel: t.lastUpdatedLabel(),
        biNames: {
            toggleOperator: 'drafts_ai_search_chip_toggle_last_updated_operator',
            editGte: 'drafts_ai_search_chip_edit_last_updated_gte',
            editLte: 'drafts_ai_search_chip_edit_last_updated_lte',
            apply: 'drafts_ai_search_chip_apply_last_updated',
            remove: 'drafts_ai_search_chip_remove_last_updated'
        },
        popoverTestIds: {
            EditPopover: LastUpdatedChipTestIds.EditPopover(),
            GteField: LastUpdatedChipTestIds.GteField(),
            LteField: LastUpdatedChipTestIds.LteField(),
            ApplyButton: LastUpdatedChipTestIds.ApplyButton(),
            ValidationError: LastUpdatedChipTestIds.ValidationError()
        }
    });
};
